import { Box, Stack, Typography } from '@mui/joy';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import RightIcon from '@MP/shared/icon/RightIcon';
import MinddImage from '@MP/shared/img/MinddImage';

const AuthHeader: FC<{ title: string; steps: string[]; active: number }> = ({ title, steps, active }) => {
  const navigate = useNavigate();
  return (
    <Stack
      direction={'row'}
      height={76}
      minHeight={76}
      bgcolor={'#FFF'}
      borderBottom={'1px solid #EDEDED'}
      alignItems={'center'}
      justifyContent={'center'}
      position={'relative'}>
      <Stack
        position={'absolute'}
        left={26}
        top={0}
        height={76}
        direction={'row'}
        alignItems={'center'}
        spacing={'16px'}>
        <Box onClick={() => navigate('/login')} display={'inline-flex'} sx={{ cursor: 'pointer' }}>
          <MinddImage />
        </Box>
        <Typography level="h4">{title}</Typography>
      </Stack>

      <Stack direction={'row'} divider={<RightIcon width={14} />} alignItems={'center'} spacing={'12px'}>
        {steps.map((step, idx) => (
          <Typography key={idx} color={idx <= active ? 'primary' : 'neutral'} fontWeight={600} level="body-sm">
            {idx + 1}. {step}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};

export default AuthHeader;
